<p>generic-file-upload-interface works!</p>
